import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyTableView from 'BasePropertyTableView.js';
import _template from 'properties/table/column-style-button.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util from 'util/Util.js';
import fontService from 'FontService';

class StyleButtonView extends BasePropertyTableView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.factoryKey = this.model.get('gridData')[this.colId].attributes['factoryKey'];

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change #buttonTextColor': 'updateColorAttributesWithValidation',
            'change #buttonTextColorPicker': 'updateColorAttributes',
            'click #buttonBoldText, #buttonItalicText': 'updateTextStyleAttributes',
            'change #buttonFontFamily, #buttonFontSize, #customButtonFontFamily': 'updateAttributes'
        };

        if (!this.columnModel.attributes['buttonTextWeight']) {
            this.columnModel.attributes['buttonTextWeight'] = 'normal !important';
            this.columnModel.attributes['buttonBoldSelection'] = this.unselectedColor;
        }

        if (!this.columnModel.attributes['buttonTextStyle']) {
            this.columnModel.attributes['buttonTextStyle'] = 'normal !important';
            this.columnModel.attributes['buttonItalicSelection'] = this.unselectedColor;
        }

        if (this.columnModel.attributes['buttonTextStyle'] === 'italic !important') {
            this.columnModel.attributes['buttonItalicSelection'] = this.selectedColor;
        }

        if (this.columnModel.attributes['buttonTextWeight'] === 'bold !important') {
            this.columnModel.attributes['buttonBoldSelection'] = this.selectedColor;
        }

        let currentFont = this.columnModel.get('buttonFontFamily');
        fontService.initCustomFont(this.columnModel, currentFont, true);

        return this;
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        var weight = this.columnModel.attributes['buttonTextWeight'];
        var style = this.columnModel.attributes['buttonTextStyle'];

        if (propName === 'buttonTextWeight') {
            if (weight.indexOf('bold') > -1) {
                this.columnModel.attributes['buttonBoldSelection'] = this.unselectedColor;
                weight = 'normal !important';
            } else {
                this.columnModel.attributes['buttonBoldSelection'] = this.selectedColor;
                weight = 'bold !important';
            }
        }

        if (propName === 'buttonTextStyle') {
            if (style.indexOf('italic') > -1) {
                this.columnModel.attributes['buttonItalicSelection'] = this.unselectedColor;
                style = 'normal !important';
            } else {
                this.columnModel.attributes['buttonItalicSelection'] = this.selectedColor;
                style = 'italic !important';
            }
        }

        this.columnModel.attributes['buttonTextWeight'] = weight;
        this.columnModel.attributes['buttonTextStyle'] = style;
        this.model.trigger('change', this.model);
    }

    updateAttributes(ev) {
        let
            propName = ev.currentTarget.name,
            propVal = ev.currentTarget.value;

        if(propName === "buttonFontFamily" || propName === "customButtonFontFamily"){
            fontService.updateCustomFont(this.columnModel, propVal, true);
            this.columnModel.attributes['buttonFontFamily'] =  propVal;
        }       

        super.updateAttributes(ev, this.model.get('gridData')[this.colId]);

        this.render();
    }


    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.columnModel.toJSON()));
        }

        const fonts = fontService.loadFontsDropDown(true);
        $("#buttonFontFamily").append(fonts);

        var self = this;

        if (this.columnModel.attributes['buttonFontFamily']) {
            let fontFamily = this.columnModel.get('buttonFontFamily');
            const customFont = fontService.isCustomFont(fontFamily);
            fontFamily = !customFont ? fontFamily : "__custom__";

            $('#buttonFontFamily')
                .find(`option[value="${fontFamily}"]`)
                .attr(`selected`, true);
        }
        if (this.columnModel.attributes['buttonFontSize']) {
            var ddValue = this.columnModel.attributes['buttonFontSize'];
            var ddl = $('#buttonFontSize');
            ddl.val(ddValue);
        }

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }

}

export default StyleButtonView;
